<template>
  <nav class="navbar navbar-expand-lg bg-body-tertiary">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"></a>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-for="link in links" :key="link.name">
            <router-link class="nav-link" :to="link.url">{{
              link.name
            }}</router-link>
          </li>
        </ul>
      </div>

      <div class="menu-right">
        <!-- Bouton email -->
        <a
          class="btn btn-link btn-email btn-icon-small d-flex border-bottom-0 text-decoration-none"
          type="button"
          href="tel:+32496939510"
        >
          <fa icon="phone"></fa>
        </a>

        <!-- Icône Dark/Light Mode -->
        <button
          class="btn btn-link btn-icon-small d-flex border-bottom-0 text-decoration-none"
          type="button"
          @click="$emit('toggle-dark-mode')"
        >
          <fa :icon="isDarkMode ? 'sun' : 'moon'"></fa>
        </button>

        <!-- Bouton Trois Points (Menu contextuel) -->
        <div class="dropdown btn-dropdown">
          <button
            class="btn btn-link btn-icon-small"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <fa icon="ellipsis-vertical"></fa>
          </button>

          <!-- Menu contextuel avec Bootstrap -->
          <ul
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenuButton"
          >
            <!-- Liens existants dans le menu -->
            <li v-for="link in links" :key="link.name">
              <router-link
                class="dropdown-item d-flex align-items-center"
                :to="link.url"
              >
                <div class="icon-container">
                  <fa v-if="link.icon" :icon="link.icon" class="me-4" />
                  <div v-else-if="link.class" :class="link.class" />
                </div>
                {{ link.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MenuVigna',
  data() {
    return {
      links: [
        { name: 'Accueil', url: '/', icon: 'home' },
        { name: 'Historique', url: '/historique', icon: ['fas', 'clock'] },
        { name: 'Matériaux', url: '/materiaux', icon: ['fas', 'hammer'] },
        {
          name: 'Conteneurs',
          url: '/conteneurs',
          class: 'smallcontainer'
        },
        {
          name: 'Terrassement',
          url: '/terrassements',
          icon: ['fas', 'person-digging']
        },
        { name: 'Devis', url: '/devis', icon: ['fas', 'file-invoice-dollar'] },
        { name: 'Contact', url: '/contact', icon: ['fas', 'envelope'] },
        { name: 'A propos de...', url: '/about', icon: 'info-circle' }
      ]
    }
  },
  props: {
    msg: String,
    isDarkMode: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style>
.menu-right {
  margin-left: auto;
  display: flex;
}

.menu-right button {
  display: flex;
  margin-top: 0.5rem;
}

.dropdown-menu {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 150px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.menu-icon {
  margin-right: 10px;
  font-size: 1.2em;
}

.menu-link {
  text-decoration: none;
  color: #333;
  flex-grow: 1;
}

.dropdown-menu-right {
  left: auto !important;
  right: 0 !important;
}

.img-icon {
  width: 18px;
  height: 18px;
  margin-right: 1.25rem;
}

.icon-container {
  width: 2.5rem;
  flex-shrink: 0;
  text-align: center;
}

.btn-email {
  align-self: center;
  padding-top: 0.65rem;
}

.btn-email svg {
  border-bottom: none !important;
}
</style>
